module.exports = __webpack_public_path__ + "img/img2.c180dd03.png";